
// @ts-nocheck test
/* eslint-disable */
import {
  computed, defineComponent, h, onMounted, ref, watch,
} from 'vue';
import { testStub } from './testStub';
import CascaderInput from '@/components/cascaderInput/CascaderInput.vue';
import MouseMoveEvent = JQuery.MouseMoveEvent;
import { ElTooltip } from "element-plus";

type PageData = {
  transcription: string;
  labels: {
    label: string;
    accuracy: number;
  }[]
}

type Coord = [number, number];
type Shape = [Coord, Coord, Coord, Coord];

export default defineComponent({
  name: 'Test',
  components: {
    CascaderInput, ElTooltip,
  },
  setup() {
    const drawShape = (ctx: CanvasRenderingContext2D, shape: Shape, fill: boolean) => {
      ctx.strokeStyle = '#f00';
      if (fill) {
        ctx.globalAlpha = 0.5;
        ctx.fillStyle = 'rgba(255, 0, 0, .4)';
      }
      ctx.beginPath();
      const [first, second, third, fourth] = shape;
      ctx.moveTo(first[1], first[0]);
      ctx.lineTo(second[1], second[0]);
      ctx.lineTo(third[1], third[0]);
      ctx.lineTo(fourth[1], fourth[0]);
      ctx.closePath();
      ctx.stroke();
      if (fill) {
        ctx.fill();
        ctx.globalAlpha = 1;
      }
    }

    const getShapeTopCenter = (shape: Shape) => {
      const [first, second, third, fourth] = shape;
      return {
        y: first[0],
        // x: second[1],
        x: (second[1] + third[1]) / 2
      }
    }


    const canvasSize = ref({
      width: 0,
      height: 0,
    });

    const shapeHovered = ref(false);
    const popoverIsVisible = ref(false);
    const popoverData = ref<PageData>(null);
    const popoverRefPosition = ref({ x: 0, y: 0 });
    const popoverTriggerRef = computed(() => ({
      getBoundingClientRect: () => DOMRect.fromRect({
        width: 0,
        height: 0,
        x: popoverRefPosition.value.x,
        y: popoverRefPosition.value.y,
      })
    }))

    onMounted(() => {
      // Loading a document.
    });

    const onOverlayMouseMove = (e: MouseMoveEvent) => {
      const { offsetX, offsetY } = e;
      const shapeIsHovered = (shape: Shape) => {
        const [first, second, third, fourth] = shape;
        const startX = first[1];
        const endX = third[1];
        const startY = first[0];
        const endY = third[0];
        return offsetX >= startX && offsetX <= endX && offsetY >= startY && offsetY <= endY;
      }
      const pageData = testStub.pages[0];
      const canvas = document.getElementById('theCanvasOverlay') as HTMLCanvasElement;
      const ctx = canvas.getContext('2d');
      let anyShapeHovered = false;
      const canvasRect = canvas.getBoundingClientRect();
      pageData.data.forEach(({ transcription, points, labels }, i) => {
        if (anyShapeHovered) {
          return;
        }
        const shape = points[0];
        console.log('check shape is hovered', shapeIsHovered(shape))
        if (shapeIsHovered(shape)) {
          console.log('shape is hovered', shape);
          if (!shapeHovered.value) {
            drawShape(ctx, shape, true);
          }
          shapeHovered.value = true;
          anyShapeHovered = true;
          const canvasRefPosition = getShapeTopCenter(shape);
          popoverRefPosition.value = {
            x: canvasRefPosition.x + canvasRect.left,
            y: canvasRefPosition.y + canvasRect.top,
          };
          popoverData.value = {
            transcription,
            labels: labels.reduce((acc, record) => {
              Object.entries(record).forEach(([ label, accuracy ]) => {
                acc.push({
                  label,
                  accuracy: Math.round(accuracy * 100)
                })
              })
              return acc;
            }, []),
          }
          popoverIsVisible.value = true;
        }
      });
      if (!anyShapeHovered) {
        shapeHovered.value = false;
      }
      if (!shapeHovered.value) {
        ctx.clearRect(0, 0, canvasSize.value.width, canvasSize.value.height)
        popoverIsVisible.value = false;
      }
    }

    return {
      canvasSize,
      popoverTriggerRef,
      popoverData,
      popoverIsVisible,
      popoverRefPosition,
      onOverlayMouseMove,
    };
  },
});
